import React, { useContext, useEffect, useState } from "react";
import style from "./Everychat.module.css";
import { Chatcontext } from "../context/Chatcontext";
import { useNavigate } from "react-router";
import { Authcontext } from "../context/Authcontext";
const Everychat = (props) => {
  const chatcontext = useContext(Chatcontext);
  const { currentuser } = useContext(Authcontext);
  const [unReadedMessage, setUnReadedMessage] = useState();
  const fetchUnReadedMessage = () => {
    props?.chat?.users?.map((user) => {
      if (user?.user_id === currentuser?.uid) {
        setUnReadedMessage(user?.un_read_message);
      }
    });
  };
  useEffect(() => {
    fetchUnReadedMessage();
  }, [currentuser?.uid,chatcontext?.chatid]);
  const navigate = useNavigate();
  const changechat = async (id) => {
    navigate("/chat");
    await chatcontext.changechat(id);
  };
  return (
    <div
      className={style.chatscard}
      onClick={() => changechat(props?.chat?.uid)}>
        {unReadedMessage >0?<p className={style.unreaded}>{unReadedMessage}</p>:null}
      <div className={style.chatcontent}>
        <p>{props?.chat?.name}</p>
        <p>
          {props?.chat?.lastmessage?.length >= 20
            ? `${props.chat.lastmessage.substring(0, 20)}...`
            : props?.chat?.lastmessage}
        </p>
      </div>
      <img src={props?.chat?.imageurl} />
    </div>
  );
};
export default Everychat;
